import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { TodoChipsListProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { Skeletons, StyledButton } from "components/common";
import TodoChipContainer from "./chipContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const TodoChipsList: React.FC<TodoChipsListProps> = (props) => {
  const {
    loading,
    todoItems,
    onGoToItemClick,
    total,
    loadingItemsCount: totalItemsForGroup,
    goToAllTodosByType,
  } = props;

  return loading ? (
    totalItemsForGroup ? (
      <Skeletons.TodoChipsListSkeleton
        totalItems={totalItemsForGroup > 10 ? 10 : totalItemsForGroup}
        columnsXs={1}
        columnsMd={2}
      />
    ) : (
      <></>
    )
  ) : (
    <>
      <Grid container direction="row" spacing={1}>
        {todoItems?.map((item, index) =>
          item ? (
            <Grid
              key={`TodoChip-${index}-id-${item.id}`}
              item
              xs={12}
              md={6}
              onClick={onGoToItemClick.bind(null, index)}
            >
              <TodoChipContainer todo={item} />
            </Grid>
          ) : (
            <Grid key={`TodoChip-${index}-id`} item xs={12} md={6}>
              <Skeletons.TodoChipSkeleton />
            </Grid>
          )
        )}
      </Grid>
      {total && total > 10 ? (
        <Grid container justifyContent="center" className={cssExports.todoWidgetWiewAllButtonContainer}>
          <StyledButton
            onClick={goToAllTodosByType}
            secondary
            size="xs"
          >{`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ViewAll)} ${total}`}</StyledButton>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default TodoChipsList;
